<template>
  <div class="teaching">
    <div class="inner">
      <SearchCommon type="teaching"/>
      <p class="pagetop"><a class="alp" href="#">ページトップへ</a></p>
    </div>
    <div class="bottom-nav">
      <ul>
        <li class="concour alp"><a href="/concour/"><span>コンクール</span></a></li>
        <li class="event alp"><a href="/event/"><span>イベント</span></a></li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}

$concour: #00a8ff;
$teaching: #f99709;
$event: #2eb024;

$white-border: 0 2px 1px #fff, 2px 0 1px #fff, 0 -2px 1px #fff, -2px 0 1px #fff,
  -2px -2px 1px #fff, 2px -2px 1px #fff, -2px 2px 1px #fff, 2px 2px 1px #fff;

.teaching {
  .inner {
    max-width: 1000px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 0 10px;
  }
  .ttl-select {
    margin: 85px 0 60px;
    @include flex();
    h2 {
      font-size: 34px;
      color: $teaching;
      font-weight: bold;
      text-shadow: $white-border;
      letter-spacing: 0.1em;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      text-shadow: $white-border;
      margin: 18px 0 0;
      letter-spacing: 0.12em;
    }
    .select-area {
      width: 60.21%;
      > div:not(.search-btn) {
        width: 39%;
        label {
          color: $teaching;
          margin-bottom: 12px;
        }
        span {
          background-color: $teaching;
        }
      }
      input {
        background-color: $teaching;
      }
    }
  }
  .card-area {
    @include flex();
    flex-wrap: wrap;
  }
  .more {
    width: 39.4%;
    margin: 56px auto 0;
    font-size: 15px;
    a {
      color: $teaching;
      border: 3px solid $teaching;
    }
    span {
      padding-left: 21px;
    }
    span:before,
    span:after {
      content: " ";
      display: block;
      border-radius: 2px;
      background: $teaching;
      position: absolute;
    }
    span:before {
      top: calc(50% - 9px);
      left: 0;
      width: 3px;
      height: 19px;
    }
    span:after {
      top: calc(50% - 0.1em);
      left: -8px;
      width: 19px;
      height: 3px;
    }
  }
  @media only screen and (max-width: 750px) {
    $white-border2: 0 1px 1px #fff, 1px 0 1px #fff, 0 -1px 1px #fff, -1px 0 1px #fff,
  -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff, 1px 1px 1px #fff;
    .inner {
      padding: 0;
    }
    .ttl-select {
      display: block;
      margin: 9.4vw 0 9.4vw;
      .ttl {
        margin-bottom: 8vw;
        text-align: center;
      }
      h2 {
        padding-left: 13vw;
        display: inline-block;
        letter-spacing: 0.05em;
        background-image: url(../assets/img/common/ico_teaching_sp.png);
        background-repeat: no-repeat;
        background-size: 11vw auto;
        background-position: center left;
        line-height: 1.4;

        font-size: 2.14rem;
      }
      p {
        margin-top: 3vw;
        font-size: 0.94rem;
        letter-spacing: 0.1em;
        text-shadow: $white-border2;
      }
      .select-area {
        flex-wrap: wrap;
        width: 100%;
        > div:not(.search-btn) {
          width: 48.5%;
        }
        label {
          color: $teaching;
        }
        span {
          background: $teaching;
          letter-spacing: 0;
        }
        input {
          width: 100%;
          background-color: $teaching;
        }
      }
      .card-area {
        display: block;
        .card {
          width: 100%;
        }
      }
    }
    .more {
      width: 100%;
      margin: 8vw auto 2vw;
      border: 1.5px solid $teaching;
      font-size: 1.28rem;
      span {
        padding-left: 4.7vw;
        &:before {
          top: calc(50% - 2.13vw);
          width: 0.8vw;
          height: 4.27vw;
        }
        &:after {
          top: calc(50% - 0.4vw);
          left: -1.7vw;
          width: 4.27vw;
          height: 0.8vw;
        }
      }
    }
  }
}
</style>

<script>
import Base from "./_Base";
import card from "../components/card";

export default {
  mixins: [Base],
  components: {
    card
  }
};
</script>
